module.exports = __webpack_public_path__ + "static/img/ttr02.623c884.png";